'use strict';

jQuery($ => {
	// Add blackout
	$('body').prepend('<div data-gecko-blackout="hidden"></div>');

	// Open menu
	$('.gecko-header-touch__toggle').on('click', function(e){
		e.preventDefault;
		$('.gecko-touch-menu').toggleClass('gecko-touch-menu--show');
		$('[data-gecko-blackout]').attr('data-gecko-blackout','show');
	});

	// Toggle the menu on blackout click
	$('[data-gecko-blackout]').on('click', function(e){
		$('.gecko-touch-menu').removeClass('gecko-touch-menu--show');
		$('[data-gecko-blackout]').attr('data-gecko-blackout','hidden');
	});

	// Single click will open the menu, double click will proceed to link
	$('.gecko-touch-menu .menu > .menu-item-has-children > a').append('<span data-gecko-mobile-action="hide"></span>');
	$('[data-gecko-mobile-action]').on('click', function(e) {
		e.preventDefault();
		var parent = $(this).parents('.menu-item-has-children');
		if (parent.hasClass('show-sub-menu')) {
			parent.removeClass('show-sub-menu');
			$(this).attr('data-gecko-mobile-action','hide');
		} else {
			parent.addClass('show-sub-menu');
			$(this).attr('data-gecko-mobile-action','show');
		}
	});

});
